<script lang="ts">
  import type { AppContext } from '../app';
  import { t } from '../i18n';
  import Icon from './icons/Icon.svelte';

  // The legend's key (S3-20). The dialog itself loads on first use (S4-03, D14: dialogs out of the start bundle).
  let { ctx }: { ctx: AppContext } = $props();
  let open = $state(false);
</script>

<button
  type="button"
  class="key"
  aria-label={$t('legend.open')}
  title={$t('legend.open')}
  onclick={() => (open = true)}
>
  <Icon name="legend" size={18} />
</button>

{#if open}
  {#await import('./LegendDialog.svelte') then { default: Dialog }}
    <Dialog {ctx} onclose={() => (open = false)} />
  {/await}
{/if}

<style>
  .key {
    position: relative;
    min-width: 36px;
    min-height: 32px;
    padding: 0 8px;
    display: grid;
    place-items: center;
    border: var(--rule-w) solid var(--rule);
  }
  .key::after {
    content: '';
    position: absolute;
    inset: -6px -2px;
  }
  .key:hover {
    border-color: var(--accent);
    color: var(--accent);
  }
</style>
